import {
    GET_ALUMNIS,
    GET_ALUMNIS_SUCCESS,
    GET_ALUMNIS_FAILED,

    GET_CURRENT_ALUMNI,
    GET_CURRENT_ALUMNI_SUCCESS,
    GET_CURRENT_ALUMNI_FAILED,

    SUBMIT_ALUMNI_FORM,
    SUBMIT_ALUMNI_FORM_SUCCESS,
    SUBMIT_ALUMNI_FORM_FAILED,

    DELETE_ALUMNI,
    DELETE_ALUMNI_SUCCESS,
    DELETE_ALUMNI_FAILED,


    IMPORT_ALUMNIS,
    IMPORT_ALUMNIS_SUCCESS,
    IMPORT_ALUMNIS_FAILED
} from '../../constants/actionTypes';

const INIT_STATE = {
    loading: false,
    alumnis: [],
    submittingForm: false,
    error: null,
    deleting: false,
    currentAlumni: null,
    importing: false
};

const AlumniReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ALUMNIS:
            return { ...state, loading: true };
        case GET_ALUMNIS_SUCCESS:
            return { ...state, alumnis: action.payload.data, total: action.payload.total, loading: false, error: null };
        case GET_ALUMNIS_FAILED:
            return { ...state, error: action.payload, loading: false };

        case GET_CURRENT_ALUMNI:
            return { ...state, loading: true };
        case GET_CURRENT_ALUMNI_SUCCESS:
            return { ...state, currentAlumni: action.payload, loading: false, error: null };
        case GET_CURRENT_ALUMNI_FAILED:
            return { ...state, error: action.payload, loading: false };

        case SUBMIT_ALUMNI_FORM:
            return { ...state, error: null, submittingForm: true };
        case SUBMIT_ALUMNI_FORM_SUCCESS:
            const alreadyExists = state.alumnis.find((alumni) => alumni.id === action.payload.id);
            let alumnis;
            let total = state.total;
            if (!alreadyExists) {
                alumnis = [action.payload, ...state.alumnis];
                total += 1;
            } else {
                alumnis = state.alumnis.map((alumni) => {
                if (alumni.id === action.payload.id) {
                  return action.payload;
                }
                return alumni;
              });
            }
            return { ...state, total,  alumnis, submittingForm: false };
        case SUBMIT_ALUMNI_FORM_FAILED:
            return { ...state, error: action.payload, submittingForm: false };

        case DELETE_ALUMNI:
            return { ...state, error: null, deleting: true };
        case DELETE_ALUMNI_SUCCESS:
            return { ...state, total: state.total - 1, alumnis: state.alumnis.filter(branch => branch.id !== action.payload) , deleting: false };
        case DELETE_ALUMNI_FAILED:
            return { ...state, error: action.payload, deleting: false };

        case IMPORT_ALUMNIS:
            return { ...state, error: null, importing: true };
        case IMPORT_ALUMNIS_SUCCESS:
            return { ...state, importing: false };
        case IMPORT_ALUMNIS_FAILED:
            return { ...state, error: action.payload, importing: false };

        default: return { ...state };
    }
}

export default AlumniReducer;